import React from 'react';
import { Stepper, Step, StepButton, CircularProgress } from '@material-ui/core';
import { useAccountContext } from '../Data/accountContext';
import CircularPercentProgress from '../../../../components/Progress/CircularPercentProgress';
import Logo from './Logo';

export default function Header({ activeForm, navigate }) {
  const { forms, account, isLoading, getFormIndex } = useAccountContext();

  const currentFormIndex = getFormIndex(activeForm);
  const onboardingPercent = parseInt(account.onboardingPercent) || 0;
  return (
    <div className="register-h">
      <div className="grd-cell-none">
        {window.location.pathname.substring(0, 4) !== '/app' && <Logo />}
      </div>

      <div>
        <div className="stepper-w">
          <Stepper nonLinear activeStep={currentFormIndex + 1} alternativeLabel>
            <Step key={0}>
              <StepButton disabled completed={true}>
                Access
              </StepButton>
            </Step>
            {forms.map((form, index) => {
              return (
                <Step key={index}>
                  <StepButton
                    disabled={isLoading}
                    onClick={() => {
                      navigate('GOTO', index);
                    }}
                    completed={currentFormIndex === index || isLoading ? false : form.isCompleted}
                  >
                    {isLoading ? (<CircularProgress color="inherit" size={20} />) : (form.label)}
                  </StepButton>
                </Step>
              );
            })}
          </Stepper>
        </div>
      </div>
      <div>
        <CircularPercentProgress
          value={onboardingPercent > 100 ? 100 : onboardingPercent}
        />
      </div>
    </div>
  );
}
